export { useAuthStore } from './auth'
export { useCustomerStore } from './customer'
export { useAccountOpeningStore } from './accountOpening'
export { useUiStore } from './ui'

/**
 * Clear persisted state from localStorage
 * Used for logout or reset operations
 */
export function clearPersistedState() {
  try {
    localStorage.removeItem('auth')
    localStorage.removeItem('customer')
    localStorage.removeItem('accountOpening')
    // Also remove legacy key
    localStorage.removeItem('sb_sso_state')
  } catch (e) {
    console.error('Error clearing persisted state:', e)
  }
}

/**
 * Reset all stores to their initial state
 * @param {Object} stores - Object containing all store instances
 */
export function resetAllStores({ authStore, customerStore, accountOpeningStore, uiStore }) {
  authStore.$reset()
  customerStore.$reset()
  accountOpeningStore.$reset()
  uiStore.$reset()
  clearPersistedState()
}
